import { PaperRate } from '../models/enums';
import { ILayerComposer, ILayout } from '../models/interfaces';
import { LayerViewModel } from '../view-models/layer-viewmodel';
import { RelocateComposer } from './relocateComposer';
import { TimeAlignmentComposer } from './timeAlignmentComposer';

export class PaperRateComposer extends RelocateComposer<PaperRate> {
    // data members

    timeLineComposer: ILayerComposer;

    // constructor

    constructor(layout: ILayout) {
        super(layout, PaperRate.mm25);

        this.timeLineComposer = new TimeAlignmentComposer(layout);
    }

    // public functions

    public isChanged() {
        return this.changeDetection.isChanged(this.layout.ecgState.chartState.paperRate);
    }

    // protected functions

    protected onUpdateAll(layers: Array<LayerViewModel>) {
        this.timeLineComposer.update(layers, true);

        super.onUpdateAll(layers);
    }

    protected onUpdate(layer: LayerViewModel) {
        super.onUpdate(layer);
    }
}
